import { createFileRoute, useSearch } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { PROTECTED, DELIVERY_NOTES } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${DELIVERY_NOTES}`;

export const Route = createFileRoute(
  '/protected/_layout/delivery-notes/_layout/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditDeliveryNoteModal,
});

function EditDeliveryNoteModal() {
  const { id } = Route.useParams();
  const search = useSearch({ strict: false }) as { subTab?: string };
  return <DocumentForm id={id} subTab={search.subTab} returnUrl={RETURN_URL} />;
}
